import { Tag, Tooltip } from "@/components/ui";
import { useCredentials } from "@/hooks/api";
import type { CredentialStatus } from "@/types/api";
import { Link } from "react-router-dom";

const STATE: Record<
  CredentialStatus,
  { label: string; tone: "positive" | "cautionary" | "negative" | "neutral"; hint: string }
> = {
  ACTIVE: {
    label: "토스증권 연결됨",
    tone: "positive",
    hint: "토스증권 API 키가 정상 동작하고 있어요.",
  },
  REVOKED: {
    label: "키 폐기됨",
    tone: "negative",
    hint: "이 키는 더 이상 쓸 수 없어요. 토스증권에서 새 키를 발급해 다시 등록해 주세요.",
  },
  IP_BLOCKED: {
    label: "허용 IP 미등록",
    tone: "negative",
    hint: "토스증권이 요청을 차단했어요. 트랑슈 고정 IP를 허용 IP 목록에 등록해 주세요.",
  },
  INVALID: {
    label: "연결 끊김",
    tone: "negative",
    hint: "키가 만료되거나 폐기됐어요. 다시 연결하면 바로 이어서 사용할 수 있어요.",
  },
};

const DISCONNECTED = {
  label: "계좌 미연결",
  tone: "cautionary" as const,
  hint: "아직 토스증권 계좌가 연결되지 않았어요.",
};

/** Dashboard header badge — the connection is the whole product's precondition. */
export function ConnectionBadge() {
  const { data, isLoading } = useCredentials();
  if (isLoading) {
    return (
      <Tag color="neutral" variant="weak" size="small">
        연결 확인 중
      </Tag>
    );
  }
  const credential = data?.[0];
  const state = credential ? STATE[credential.status] : DISCONNECTED;
  const needsFix = state.tone === "negative" || state.tone === "cautionary";

  // 헤더 최상단이라 위로 띄우면 뷰포트 밖으로 잘립니다 — 아래로 엽니다.
  const badge = (
    <Tooltip label={state.hint} placement="bottom">
      <span className="inline-flex">
        <Tag color={state.tone} variant="weak" size="small">
          {state.label}
        </Tag>
      </span>
    </Tooltip>
  );

  return needsFix ? <Link to="/settings/api-key">{badge}</Link> : badge;
}
